<script lang="ts">
    import { getContext } from "svelte";
    import { fade } from "svelte/transition";

    import type { Writable } from "svelte/store";
    import type { SkinState } from "../../types/state";

    import PlayBtn from "./PlayBtn.svelte";
    import VolumeCtrl from "./VolumeCtrl.svelte";
    import Time from "./Time.svelte";
    import FullscreenBtn from "./FullscreenBtn.svelte";
    import SettingsBtn from "./SettingsBtn.svelte";

    import { overlayTransitionDuration } from "../../utils/constants";

    let skinState: Writable<SkinState> = getContext("skinState");

    $: showOverlay = !$skinState.isOverlayHidden || $skinState.isSettingsOpen;
</script>

{#if showOverlay}
    <div
        class="controls"
        transition:fade={{ duration: overlayTransitionDuration }}
    >
        <PlayBtn />
        <VolumeCtrl />
        <div class="spacer" />
        <Time />
        <SettingsBtn />
        <FullscreenBtn />
    </div>
{/if}

<style type="text/scss" lang="scss">
    .controls {
        position: absolute;
        display: flex;
        align-items: flex-end;
        flex-wrap: nowrap;

        width: 100%;
        min-height: calc(2em + 0.2em);

        position: absolute;
        bottom: 0;

        .spacer {
            flex: 1;
        }
    }
</style>
